// Table viz — generic data table for any panel result. Honours an
// optional panel.tableLimit cap so big result sets don't blow up the
// report. The panel header surfaces "showing N of M" when capped.

import { formatTypedCell, jsonSafeReplacer } from '../../../data/cell-format.js';

function isNumericCell(v) {
  if (typeof v === 'number') return Number.isFinite(v);
  // B607: an INT past 2^53 arrives as a BigInt and still belongs in the
  // right-aligned numeric column.
  if (typeof v === 'bigint') return true;
  if (typeof v === 'string') return /^-?\d+(\.\d+)?$/.test(v);
  return false;
}

function fmtCell(v) {
  if (v == null) return '—';
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  // B607: `Bytes` → `\x…` hex, `Int` past 2^53 → every digit, `Vector` → a
  // bracketed list, `Blob` → its chunk count. Returns null for everything the
  // two lines below already handled, so nothing else changes.
  const typed = formatTypedCell(v);
  if (typed !== null) return typed;
  if (typeof v === 'object') return JSON.stringify(v, jsonSafeReplacer);
  return String(v);
}

export function TableViz({ columns, rows, error, loading, panel }) {
  if (error) return <div className="report-viz-empty error">{error}</div>;
  if (loading && !rows) return <div className="report-viz-empty">Loading…</div>;
  if (!rows?.length) return <div className="report-viz-empty">No rows</div>;

  const limit = Number.isFinite(panel?.tableLimit) ? panel.tableLimit : null;
  const shown = limit ? rows.slice(0, limit) : rows;

  return (
    <div className="report-viz-table">
      <table className="k-table">
        <thead>
          <tr>{columns?.map(c => <th key={c}>{c}</th>) ?? null}</tr>
        </thead>
        <tbody>
          {shown.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} className={isNumericCell(cell) ? 'num' : ''}>{fmtCell(cell)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {limit && rows.length > limit && (
        <div className="report-viz-foot">Showing {limit} of {rows.length}</div>
      )}
    </div>
  );
}
